import VNavBar from './VNavBar.vue';

export { VNavBar };
export default VNavBar;
